import { render, staticRenderFns } from "./TheBottomArea.vue?vue&type=template&id=3a8009b2&scoped=true&"
import script from "./TheBottomArea.vue?vue&type=script&lang=js&"
export * from "./TheBottomArea.vue?vue&type=script&lang=js&"
import style0 from "./TheBottomArea.vue?vue&type=style&index=0&id=3a8009b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8009b2",
  null
  
)

export default component.exports